module.exports = __webpack_public_path__ + "img/03.21737cc8.png";